export default {
  site: 'historyextra',
  header: {
    logo: 'primary',
    eyebrowLogo: 'secondary',
    eyebrowColour: 'dark',
    strapline: 'The official website for BBC History Magazine and BBC History Revealed'
  },
  siteIdentity: {
    logo: {
      url: 'https://images.immediate.co.uk/production/volatile/sites/7/2021/09/HeX-logo-dark-b2d1ee8.png',
      alt: 'History Extra logo',
      width: 800,
      height: 207
    },
    secondaryLogo: {
      url: 'https://images.immediate.co.uk/production/volatile/sites/7/2021/09/HeX-logo-light-9329121.png',
      alt: 'History Extra logo',
      width: 800,
      height: 207
    }
  }
};